<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <md-field name="enterprise_name">
          <label for="name">Business name</label>
          <md-input name="name" id="name" v-model="localEnterprise.name" />
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field name="enterprise_name">
          <label for="email">E-mail</label>
          <md-input name="email" id="email" v-model="localEnterprise.email" />
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field name="kind">
          <label for="kind">Plan</label>
          <md-select name="kind" id="kind" v-model="localEnterprise.owner.kind">
            <md-option
              v-for="option in settableKinds"
              v-bind:key="option.id"
              v-bind:value="option.id">
              {{ option.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <md-field name="enterprise_name">
          <label for="subscription_type">Subscription type</label>

          <md-select v-model="localEnterprise.payg">
            <md-option v-bind:value="true">Metered</md-option>
            <md-option v-bind:value="false">Standard</md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field name="sCustomerId">
          <label for="sCustomerId">Stripe Customer ID</label>
          <md-input name="sCustomerId" id="sCustomerId"
            v-model="localEnterprise.owner.sCustomerId" />
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field name="subscriptionId">
          <label for="subscriptionId">Stripe Subscription ID</label>
          <md-input name="subscriptionId" id="subscriptionId"
            v-model="localEnterprise.owner.subscriptionId" />
        </md-field>
      </div>
    </div>

    <div class="md-layout" v-if="localEnterprise.owner.kindName == 'Trial'">
      <div class="md-layout-item md-small-size-100 mb-1">
        <md-field name="trialComplete" class="md-has-value trial-complete">
          <label for="trialComplete">Trial complete date (DD/MM/YYYY)</label>
          <datetime
            id="trialComplete"
            type="datetime"
            input-class="md-input"
            format="dd/MM/yyyy HH:mm:ss"
            v-model="localEnterprise.owner.trialComplete" />
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <md-field name="seats">
          <label for="seats">Seats</label>
          <md-input name="seats" id="seats" v-model="localEnterprise.seats" />
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field name="seats">
          <label for="seats">Allocated documents</label>
          <md-input name="allocated" id="allocated" v-model="localEnterprise.allocated" />
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field name="payg">
          <label for="payg">Pay as you go?</label>
          <md-select name="payg" id="payg" v-model="localEnterprise.payg">
            <md-option :value="false">No</md-option>
            <md-option :value="true">Yes</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <md-field name="seats">
          <label for="seats">Document quota</label>
          <md-input name="document-quota" id="quota" v-model="localEnterprise.quota" />
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field name="seats">
          <label for="seats">SMS quota</label>
          <md-input name="sms-quota" id="quota" v-model="localEnterprise.smsQuota" />
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <md-field name="identity-quota">
          <label for="identity-quota">Identity quota</label>
          <md-input
            name="identity-quota"
            id="identity-quota"
            v-model="localEnterprise.identityRequestQuota"
          />
        </md-field>
      </div>
    </div>
    <div class="md-layout-item md-small-size-100">
      <md-field name="subscriptionInterval">
        <label for="subscriptionInterval">Subscription Interval</label>
        <md-select name="subscriptionInterval"
          id="subscriptionInterval"
          v-model="localEnterprise.owner.subscriptionInterval"
        >
          <md-option value="month">month</md-option>
          <md-option value="year">year</md-option>
        </md-select>
      </md-field>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100 mb-1">
        <md-field name="quotaRenewedOn" class="md-has-value quota-renewed-on">
          <label for="quotaRenewedOn">Last Year Quota Renewed Date (DD/MM/YYYY)</label>
          <datetime
            id="quotaRenewedOn"
            type="datetime"
            input-class="md-input"
            format="dd/MM/yyyy HH:mm:ss"
            v-model="localEnterprise.owner.quotaRenewedOn" />
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field name="annualCommitmentMonthlyBilling">
          <label for="annualCommitmentMonthlyBilling">Annual Plan Billed Monthly</label>
          <md-select
            name="annualCommitmentMonthlyBilling"
            id="annualCommitmentMonthlyBilling"
            v-model="localEnterprise.owner.annualCommitmentMonthlyBilling">
            <md-option :value="true">Yes</md-option>
            <md-option :value="false">No</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.trial-complete .vdatetime-popup {
  top: 50vh;
  left: 10vw;
}
.quota-renewed-on .vdatetime-popup {
  top: 120vh;
  left: 20vw;
}
</style>
<script type="ts">
import { Datetime } from 'vue-datetime';

export default {
  name: 'enterprise-update-form',
  props: ['enterprise'],
  components: { Datetime },
  computed: {
    localEnterprise: {
      get() {
        return this.enterprise;
      },
      set(value) {
        this.$emit('enterpriseChange', value);
      },
    },
  },
  data: () => ({
    settableKinds: [
      { id: 0, name: 'Free forever' },
      { id: 1, name: 'API' },
      { id: 2, name: 'Entrepreneur' },
      { id: 3, name: 'Enterprise' },
      { id: 6, name: 'Trial' },
      { id: 7, name: 'Business' },
      { id: 8, name: 'Business pro' },
    ],
  }),
};
</script>
